import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { ChartSpecification } from '../../../../dataModels/chart-data-model';

declare var AmCharts;

@Component({
    selector: 'multiple-lines-bars-chart',
    templateUrl: 'multiple-lines-bars.component.html',
    styleUrls: ['multiple-lines-bars.component.css', '../../charts.style.scss']
})

export class MultipleLinesBarsChartComponent implements OnInit, AfterViewInit {

    @Input() chartSpecification: ChartSpecification;
    chart: any;

    constructor() { }

    ngOnInit() {
        this.chartSpecification.title = this.chartSpecification.title || "";
        this.chartSpecification.theme = this.chartSpecification.theme || "none";
        this.chartSpecification.chartColor = this.chartSpecification.chartColor || "";
        this.chartSpecification.data = this.chartSpecification.data || [];
        this.chartSpecification.yAxisTitle = this.chartSpecification.yAxisTitle || "";
        this.chartSpecification.xAxis = this.chartSpecification.xAxis || "xAxis";
        this.chartSpecification.yAxis = this.chartSpecification.yAxis || "yAxis";
        this.chartSpecification.divId = this.chartSpecification.divId || "multiDiv";
        this.chartSpecification.graphs = this.chartSpecification.graphs || [];
        this.chartSpecification.valueAxes = this.chartSpecification.valueAxes || [];
        this.chartSpecification.precision = this.chartSpecification.precision || 0;

        if (typeof this.chartSpecification.parseDates === "undefined") {
            this.chartSpecification.parseDates = true;
        }
    }

    ngAfterViewInit() {
        this.drawChart();
    }

    drawChart() {
        setTimeout(() => {
            AmCharts.makeChart(this.chartSpecification.divId, {
                "hideCredits": true,
                "type": "serial",
                "theme": this.chartSpecification.theme,
                "titles": [{
                    "size": 12,
                    "text": this.chartSpecification.title
                }],
                //"dataDateFormat": "YYYY-MM-DD",
                "precision": 2,
                "valueAxes": this.getValueAxes(),
                "graphs": this.getGraphs(),
                "chartCursor": {
                    "pan": true,
                    "valueLineEnabled": true,
                    "valueLineBalloonEnabled": true,
                    "cursorAlpha": 0,
                    "valueLineAlpha": 0.2
                },
                "categoryField": this.chartSpecification.xAxis,
                "categoryAxis": {
                    "parseDates": this.chartSpecification.parseDates,
                    "dashLength": 1,
                    "minorGridEnabled": true,
                    "gridThickness": 0
                },
                "legend": {
                    "useGraphSettings": true,
                    "valueText": ""
                },
                "balloon": {
                    "borderThickness": 1,
                    "shadowAlpha": 0
                },
                "export": {
                    "enabled": true,
                    "fileName": this.chartSpecification.title
                },
                "dataProvider": this.chartSpecification.data
            });
        }, 20);
    }

    getGraphs() {
        let graphs: any[] = [];;

        this.chartSpecification.graphs.forEach((item, index) => {
            if (item.bullet != '') {
                graphs.push({
                    "id": "g" + (index + 1),
                    "valueAxis": item.valueAxis,
                    "bullet": item.bullet,
                    "bulletBorderAlpha": 1,
                    "bulletColor": item.bulletColor,
                    "bulletSize": 5,
                    "hideBulletsCount": 50,
                    "lineThickness": 2,
                    "lineColor": item.color,
                    "type": item.GraphType,
                    "title": item.title,
                    "useLineColorForBulletBorder": true,
                    "valueField": item.fieldName,
                    "balloonText": "[[title]]<br /><b style='font-size: 100%'>[[value]]</b>",
                    "precision": this.chartSpecification.precision
                });
            }
            else {
                graphs.push({
                    "id": "g" + (index + 1),
                    "valueAxis": item.valueAxis,
                    "lineColor": item.color,
                    "fillColors": item.color,
                    "fillAlphas": 1,
                    "type": item.GraphType,
                    "title": item.title,
                    "valueField": item.fieldName,
                    "clustered": false,
                    "columnWidth": item.columnWidth || 0.7,
                    "legendValueText": "$[[value]]M",
                    "balloonText": "[[title]]<br /><b style='font-size: 100%'>[[value]]</b>",
                    "precision": this.chartSpecification.precision
                });
            }
        });

        return graphs
    }

    getValueAxes() {
        let axes: any[] = [{
            "id": "v1",
            "title": this.chartSpecification.valueAxes[0].title,
            "position": this.chartSpecification.valueAxes[0].position,
            "axisAlpha": 0,
            "axisThickness": 0
        }];

        if (this.chartSpecification.valueAxes.length > 1) {
            this.chartSpecification.valueAxes.slice(1).forEach((item, index) => {
                axes.push({
                    "id": "v" + (index + 2),
                    "title": item.title,
                    "position": item.position,
                    "gridAlpha": 0,
                    "axisAlpha": 0,
                    "axisThickness": 0
                });
            });
        }
        return axes;
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/gaugeCharts/multiple-lines-bars/multiple-lines-bars.component.ts